import { useContext, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { DataContext } from "../../context/DataContext";
import { clubPost } from "./clubApi";
import { consoleColors } from "../admin/consoleTheme";
import { formatAmount } from "../../include/money";
import { indiaDate } from "../../include/indiaDate";

export default function ClubWallet() {
  const { clubData } = useContext(DataContext);
  const clubId = clubData?.club_info?.club_id;
  const [wallet, setWallet] = useState(0);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!clubId) return;
    clubPost("CLUB_WALLET", { club_id: clubId }).then((result) => {
      if (result.status === "200") {
        setWallet(Number(result.data?.club?.wallet_amount || 0));
        setRows(result.data?.rows || []);
      }
    });
  }, [clubId]);

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, display: "grid", gap: 2 }}>
      <Box sx={{ background: "#fff", border: `1px solid ${consoleColors.line}`, borderRadius: 2.5, p: 2 }}>
        <Typography sx={{ fontSize: 13, color: consoleColors.muted }}>Club wallet</Typography>
        <Typography sx={{ fontSize: 28, fontWeight: 750 }}>₹{formatAmount(wallet)}</Typography>
        <Typography sx={{ fontSize: 13, color: consoleColors.muted, mt: 0.5 }}>Used when this club requests printed loyalty cards.</Typography>
      </Box>
      <Box sx={{ background: "#fff", border: `1px solid ${consoleColors.line}`, borderRadius: 2.5, p: { xs: 2, md: 3 } }}>
        <Typography sx={{ fontSize: 16, fontWeight: 750, mb: 1.2 }}>Transaction history</Typography>
        {rows.length === 0 && <Typography sx={{ color: consoleColors.muted, fontSize: 14 }}>No wallet transactions yet.</Typography>}
        <Box sx={{ display: "grid", gap: 0.8 }}>
          {rows.map((row) => (
            <Box key={row.row_temp_id} sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "0.7fr 0.7fr 1.6fr 0.9fr" }, gap: 1, borderTop: `1px solid ${consoleColors.line}`, py: 0.8 }}>
              <Typography sx={{ fontSize: 14 }}>{row.wallet_action === "Sub" ? "Cut" : "Add"}</Typography>
              <Typography sx={{ fontSize: 14, fontWeight: 700 }}>₹{formatAmount(row.wallet_amount)}</Typography>
              <Typography sx={{ fontSize: 14, color: consoleColors.muted }}>{row.comment || "—"}</Typography>
              <Typography sx={{ fontSize: 14 }}>{indiaDate(row.date_added)}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
